import React, {useState} from "react";
import {FilterSearchModal} from "./FilterSearchModal";

// `titleContent` (optional) replaces the plain <h3> title — used by the color
// sections to render a tab group in the header. `headerClassName` lets those
// sections opt into the tabbed-header layout. `visibleRows` (optional) caps the
// scroll body to exactly that many option-row heights, so opted-in cards show a
// fixed number of row slots and scroll for any extra options. Sections are
// always expanded (no collapse toggle).
//
// Expanded search (optional): pass `expandable` to surface a hover-revealed
// "See more" button that opens a larger, searchable modal of the same options.
// The section owns nothing but the modal's open/close boolean — selection stays
// in the store. It re-uses the SAME `items`/`isSelected`/`onToggle` (plus
// `getLabel`/`getSecondary`/`renderDot`) the section's BarFilter already gets, so
// the modal and the inline list are always in sync (no duplicated filter state).
// The button only appears once the option count exceeds `expandThreshold`.
export function SidebarSection({
    title,
    titleContent,
    headerClassName = "",
    badge,
    visibleRows,
    children,
    expandable = false,
    expandThreshold = 8,
    modalTitle,
    items,
    isSelected,
    onToggle,
    getLabel,
    getSecondary,
    renderDot,
}) {
    const [modalOpen, setModalOpen] = useState(false)

    const optionCount = (items || []).length
    const showSeeMore = expandable && optionCount > expandThreshold
    const heading = modalTitle || title

    return (
        <div className="sidebar-section">
            <div className={`section-header ${headerClassName}`.trim()}>
                {
                    titleContent || (
                        <h3>
                            {title}
                            {badge !== undefined && (
                                <span style={{
                                    fontSize: 11,
                                    fontWeight: 500,
                                    color: "var(--muted)",
                                    background: "var(--bg)",
                                    borderRadius: 10,
                                    padding: "1px 7px",
                                    marginLeft: 4
                                }}>
                                    {badge}
                                </span>
                            )}
                        </h3>
                    )
                }
                {
                    showSeeMore &&
                    <button
                        type="button"
                        className="section-see-more"
                        aria-label={`See all ${heading} options`}
                        aria-haspopup="dialog"
                        onClick={() => setModalOpen(true)}
                    >
                        See more
                    </button>
                }
            </div>
            <div
                className={`section-body scroll-body${visibleRows ? " scroll-body--fixed-rows" : ""}`}
                style={visibleRows ? {"--visible-rows": visibleRows} : undefined}
            >
                {children}
            </div>
            {
                showSeeMore &&
                <FilterSearchModal
                    isOpen={modalOpen}
                    setIsOpen={setModalOpen}
                    title={heading}
                    items={items}
                    isSelected={isSelected}
                    onToggle={onToggle}
                    getLabel={getLabel}
                    getSecondary={getSecondary}
                    renderDot={renderDot}
                />
            }
        </div>
    );
}
